import React from 'react';
import SterlingDrawer from '../../../../sterling/SterlingDrawer';
import { Button, Text } from '@blueprintjs/core';

interface ITimeProps {
    current: number
    loop: string | null
    nextTime: () => void
    previousTime: () => void
}

const Time: React.FunctionComponent<ITimeProps> = props => {

    const {
        current,
        nextTime,
        previousTime
    } = props;

    return (
        <SterlingDrawer.Section title={'Time'}>
            <div style={{display: 'flex', alignItems: 'center'}}>
                <Button
                    icon={'chevron-left'}
                    minimal={true}
                    onClick={previousTime}/>
                <Text>{ current }</Text>
                <Button
                    icon={'chevron-right'}
                    minimal={true}
                    onClick={nextTime}/>
                {
                    props.loop && <Text>Loop: {props.loop}</Text>
                }
            </div>
        </SterlingDrawer.Section>
    )

}

export default Time;
